import { Fragment, useEffect, useState } from "react";
import styles from "./antheRsTable.module.css";
import config from "../../../../config";
const ScoreCardTable = ({ Response, scoreCard, exam_type }) => {
  const [score, setScore] = useState([]);

  useEffect(() => {
    let arr = scoreCard;
    setScore(arr);
  }, [scoreCard]);

  //IAT Case removed highest score
  useEffect(() => {
    if (exam_type === "IAT") {
      const filtered = scoreCard.filter(item => item.metric !== "Highest Scores");
      setScore(filtered);
    } else {
      setScore(scoreCard); // default for other exam types
    }
  }, [exam_type, scoreCard]);
  //IAT Case removed highest score
  const formatLabel = (text) => {
    return text.toUpperCase() === "IQ"
      ? "IQ"
      : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
  return (
    <Fragment>
      {score?.length > 0 ? (
        <div className={`${styles.tableWrapper} mb-5`}>
          <div style={{ minWidth: "400px" }}>
            <div className={styles.score_card_section}>
              <h1
                style={{
                  color: exam_type === 'IAT' || exam_type === 'iACST' ? '#009CDE' : '#2B7DCA',
                  fontFamily: "Outfit-Medium",
                  marginBottom: "1.5rem",
                }}
              >
                <b>
                  YOUR SCORE CARD {' '}
                  {exam_type === "iACST" ? " " : exam_type === "IAT" ? " " : ``}
                </b>
              </h1>
            </div>
            <table
              className={styles.antheScoreTable}
              style={{
                // fontSize: '45px',
                fontWeight: "500",
                fontFamily: "Outfit-Regular!important",
                margin: 0,
              }}
            >
              <thead className={styles.antheScoreThead}>
                <tr className={styles.antheScoreTr}>
                  {/* <th>{props.rollNumber}</th> */}
                  <th
                    className={styles.antheScoreTh}
                    style={{ textAlign: "left  " }}
                  >
                    Roll Number. ({Response.profile.roll_number})
                  </th>

                  {score &&
                    score[0]?.subjects.map((ele, i) => {
                      return (
                        <th
                          key={i}
                          style={{ textAlign: "center" }}
                          className={styles.antheScoreTh}
                        >
                          {/* {ele.charAt(0).toUpperCase() +
                            ele.slice(1).toLowerCase()} */}
             {formatLabel(ele)}

                        </th>
                      );
                    })}
                </tr>
              </thead>
              <tbody className={styles.antheScoreTbody}>
                {score.map((ele, j) => {
                  // console.log('inside',ele.metric)

                  return (
                    <tr className={styles.antheScoreTr} key={j}>
                      <td style={{ textAlign: "left", fontWeight: "bold" }}>
                        {ele.metric}
                      </td>
                      {ele &&
                        ele?.values?.map((e, key) => {
                          return (
                            <td key={key}>
                              {e === "null" || e === null ? 0 : e}
                            </td>
                          );
                        })}
                    </tr>
                  );
                })}
                {/* {scoreCard.map((ele) => {
                                    return (
                                        <tr
                                            className={styles.antheScoreTr}
                                            key={ele}
                                        >
                                            {ele.map((item, ind) => {
                                                return (
                                                    <td
                                                        key={item}
                                                        style={
                                                            ind === 0
                                                                ? {
                                                                      textAlign:
                                                                          'start',
                                                                  }
                                                                : null
                                                        }
                                                        className={styles.antheTd}
                                                    >
                                                        {item}
                                                    </td>
                                                )
                                            })}
                                        </tr>
                                    )
                                })} */}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default ScoreCardTable;
